import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-commission-config',
  templateUrl: './create-commission-config.component.html',
  styleUrls: ['./create-commission-config.component.scss']
})
export class CreateCommissionConfigComponent implements OnInit {

  commissionForm: FormGroup;
  templateArr = []
  showMessage: boolean = false;
	alertType = '';
  message: string = ``;
  submitted : boolean
  AllMasterClient: string = "false";

  dropdownSettings:IDropdownSettings;

  airlineList: any;
  clientList: any;
  supplierList: any;
  selectedAirline: any;
  selectedClient: any;
  selectedSupplier: any;

  @ViewChild('accountAC',{static : true}) accountAC;
  constructor(
    private fb: FormBuilder,
    public commonService: CommonServiceService,
    private spinner : NgxSpinnerService
  ) {
    
    this.selectedAirline ='';
    this.selectedClient = '';
    this.selectedSupplier = '';

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'account_code',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  async ngOnInit() {
    this.initialiseFormControl()

    let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
		let inv_config = globalSettingConfig.filter(el=>el.group=='FLIGHT_INV')
		if(inv_config && inv_config.length>0){
			console.log("inv_config[0].json_doc",inv_config[0].json_doc["value"])
			let flight_config = inv_config[0].json_doc["value"].filter(el=>el.key=='ALL MASTERS IN CLIENT')
			if(flight_config && flight_config.length){
				this.AllMasterClient = flight_config[0].value
			}
    }

    
    this.spinner.show()
    this.airlineList = await this.getAccountsList('globalsearch/airline')
    if(this.AllMasterClient=="true"){
      this.clientList = await this.getAccountsList('client/autocomplete?status=active&client_type=all')
    }else{
      this.clientList = await this.getAccountsList('globalsearch/client')
    }

    this.supplierList = await this.getAccountsList('util/getsupplierairline')

    this.spinner.hide()
   
  }
 initialiseFormControl (){
    this.commissionForm = this.fb.group({
			'commission_type': ['received',[Validators.required]],
			'transcation_type': ['all',[Validators.required]],
      'start_date' : ['',[Validators.required]],
      'end_date' : ['',[Validators.required]],
      'invoice_type': ['' ],
      'selected_airline' : [''],
      'selected_client' : [''],
      'selected_supplier' : [''],
      'airline_name': [''],
      'supplier_name' : [''],
      'client_name' : [''],
      'iata_type' : ['RB'],
      'iata_value' : [0],
      'plb_type' : ['RB'],
      'plb_value' : [0],
      'cashback_type' : ['RB'],
      'cashback_value' : [0],
      'discount_type' : ['VL'],
      'discount_value' : [0],
      'discRecallValue' : [''],
      'com_type' : ['RB'],
      'commission_value' : [0]
    })
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  getAccountsList(apiEndpoint) {
    return new Promise(async (resolve, reject) => {
    this.commonService.getRequestNoloader(`${environment.okountUrl}/${apiEndpoint}`).subscribe((res : any) => {
      if(apiEndpoint == 'util/getsupplierairline' || apiEndpoint == 'client/autocomplete?status=active&client_type=all'){ 
        resolve(res)
      } else {
        resolve(res['data'])
      }
    }, err => {
      resolve([])
    })
  })
  }


  submit(value){
    // this.selectedAirline = this.createAccountreq(value.selectedAirline,this.airlineList)
    // this.selectedClient = this.createAccountreq(value.selectedClient,this.clientList)
    // this.selectedSupplier = this.createAccountreq(value.selectedSupplier,this.supplierList)

    // let start_date = moment(value.start_date);
    // let end_date = moment(value.end_date);

    // let daysDiff = end_date.diff(start_date, 'days');
    // if (daysDiff > 15) {
    //   this.showMessage = true;
    //   this.alertType = 'error-box'
    //   this.message = 'The difference is greater than 15 days.';
    //   return;
    // } 

      let invalid = []
		  const controls = this.commissionForm.controls;
	    	for (const name in controls) {
          if (controls[name].invalid) {
              invalid.push(name);
            }
        }

        if(invalid.length > 0) { 
          this.showMessage = true;
          this.alertType = 'error-box'
          this.message = 'Please fill the mandatory fields';
          return;
        }
        if(['all','credit-note','invoice'].includes(this.commissionForm.controls.transcation_type.value) && (!this.commissionForm.controls.invoice_type.value)  ){
          this.showMessage = true;
          this.alertType = 'error-box'
          this.message = 'Please Select INV TYPE';
          return;
        }

        this.submitted = true;
        this.commonService.postRequest(`${environment.okountUrl}/commission-config`, value).subscribe(
          (res: any) => {
            let response = res
            debugger
				console.log('Response : ', response)
				this.showMessage = true
				this.alertType = 'success-box'
				this.message = response['message'] ? response['message'] : `Updating data`;
				this.spinner.hide()
			},
			err => {
				window.scroll(0, 0)
				this.showMessage = true;
				this.alertType = 'error-box';
				this.message = err['error']['message']
				this.spinner.hide()
			}
		);
  }

  createAccountreq(selectedAccountArr,allAccount){
    let selectedAccount = []
    for (const key in selectedAccountArr) {
      if (Object.prototype.hasOwnProperty.call(selectedAccountArr, key)) {
        var element = selectedAccountArr[key];
        let selectedData = allAccount.filter(option => {
          return option.account_code == element.account_code
        })
        if (selectedData && selectedData.length > 0) {
          selectedAccount.push(selectedData[0])
        }
      }
    }
    return selectedAccount
  }

  hideError() {
		this.showMessage = false
  }
  
  reset(){
    this.selectedAirline = '';
    this.selectedClient = '';
    this.selectedSupplier = '';
    this.initialiseFormControl()
  }
  getAirlineName(account_code) {
		let selectedAirline = this.airlineList.filter(option => {
			return option.account_code == account_code;
		})
		if (selectedAirline.length > 0) {
			this.commissionForm.controls.airline_name.setValue(selectedAirline[0].name)
		}
	}
  getClientName(account_code) {
		let selectedClient = this.clientList.filter(option => {
			return option.account_code == account_code;
		})
		if (selectedClient.length > 0) {
			this.commissionForm.controls.client_name.setValue(selectedClient[0].name)
		}
	}
  getSupplierName(account_code) {
		let selectedSupplier = this.supplierList.filter(option => {
			return option.account_code == account_code;
		})
		if (selectedSupplier.length > 0) {
			this.commissionForm.controls.supplier_name.setValue(selectedSupplier[0].name)
		}
	}
  changeCommissionType(value) {
    if (value == 'received') {
      this.commissionForm.controls.selected_client.setValue('')
      this.commissionForm.controls.client_name.setValue('')
    } else {
      this.commissionForm.controls.selected_supplier.setValue('')
      this.commissionForm.controls.supplier_name.setValue('')
    }
  }

}
